/**
 * window.DKSampleConfirm — a small confirm sheet shown before a wallpaper
 * sample is added to the cart, so the shopper picks the EXACT material they
 * want to feel (they were ordering the default material by mistake).
 *
 * Usage:
 *   DKSampleConfirm.open({
 *     materials: [{ id, label }],   // chips
 *     currentId,                    // pre-highlighted material
 *     priceText: '₺200',
 *     onSelect(id),                 // chip tapped → picker switches material live
 *     onConfirm(id),                // "Add sample" → add the sample for id
 *   });
 */
(function () {
  var SEL = '.dk-sampleconfirm__overlay';

  function close() {
    var ex = document.querySelector(SEL);
    if (ex) {
      ex.classList.remove('is-open');
      document.removeEventListener('keydown', onKey);
      var node = ex;
      setTimeout(function () { if (node && node.parentNode) node.parentNode.removeChild(node); }, 200);
    }
  }

  function onKey(e) {
    if (e.key === 'Escape') close();
  }

  function open(opts) {
    opts = opts || {};
    var materials = opts.materials || [];
    if (!materials.length) { if (opts.onConfirm) opts.onConfirm(opts.currentId); return; }
    close();

    var chosen = opts.currentId || materials[0].id;
    var price = opts.priceText || '200\u20BA';

    var HINTS = {
      'Dokusuz': 'P\u00fcr\u00fczs\u00fcz mat y\u00fczey',
      'Dokulu': 'Kuma\u015f dokusu, duvar izlerini gizler',
      'Folyo': 'Kendinden yap\u0131\u015fkanl\u0131, silinebilir',
      'Tekstil': 'Premium kuma\u015f doku'
    };

    var overlay = document.createElement('div');
    overlay.className = 'dk-sampleconfirm__overlay';

    var sheet = document.createElement('div');
    sheet.className = 'dk-sampleconfirm';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-label', 'Numune sipariş edin');

    sheet.innerHTML =
      '<button type="button" class="dk-sampleconfirm__close" aria-label="Kapat">&times;</button>' +
      '<h3 class="dk-sampleconfirm__title">Numune sipariş edin</h3>' +
      '<p class="dk-sampleconfirm__sub">Hangi malzemeyi elinizde incelemek istersiniz? Tanesi ' + price + ' — birini seçin:</p>' +
      '<div class="dk-sampleconfirm__chips"></div>' +
      '<button type="button" class="dk-sampleconfirm__cta">Numuneyi sepete ekle · ' + price + '</button>';

    var chipsWrap = sheet.querySelector('.dk-sampleconfirm__chips');

    function renderChips() {
      chipsWrap.innerHTML = '';
      materials.forEach(function (m) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'dk-sampleconfirm__chip' + (m.id === chosen ? ' is-active' : '');
        var hint = m.hint || HINTS[m.label] || '';
        b.innerHTML =
          (m.popular ? '<span class="dk-sampleconfirm__chip-tag">En Pop\u00fcler</span>' : '') +
          '<span class="dk-sampleconfirm__chip-check" aria-hidden="true"><svg viewBox="0 0 12 12" width="10" height="10" fill="none"><path d="M2 6.2 4.8 9 10 3.4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
          '<span class="dk-sampleconfirm__chip-label"></span>' +
          (hint ? '<span class="dk-sampleconfirm__chip-hint"></span>' : '');
        b.querySelector('.dk-sampleconfirm__chip-label').textContent = m.label;
        if (hint) b.querySelector('.dk-sampleconfirm__chip-hint').textContent = hint;
        b.addEventListener('click', function () {
          chosen = m.id;
          renderChips();
          if (opts.onSelect) opts.onSelect(m.id);
        });
        chipsWrap.appendChild(b);
      });
    }
    renderChips();

    sheet.querySelector('.dk-sampleconfirm__cta').addEventListener('click', function () {
      var id = chosen;
      close();
      if (opts.onConfirm) opts.onConfirm(id);
    });
    sheet.querySelector('.dk-sampleconfirm__close').addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', onKey);

    overlay.appendChild(sheet);
    document.body.appendChild(overlay);
    // next frame → enable transition
    requestAnimationFrame(function () { overlay.classList.add('is-open'); });
  }

  window.DKSampleConfirm = { open: open, close: close };
})();
